import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import OTPVerification from 'pages/Auth/OTPVerification';
import ResetPassword from 'pages/Auth/ResetPassword';
const ForgotPassword = Loadable(lazy(() => import('pages/Auth/ForgotPassword')));
// render - login
const AuthLogin = Loadable(lazy(() => import('pages/Auth/Auth')));
// ==============================|| AUTH ROUTING ||============================== //
const LoginRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: 'login',
      element: <AuthLogin />
    },
    {
      path: 'forgotpass',
      element: <ForgotPassword />
    },
    {
      path: 'otpverify',
      element: <OTPVerification />
    },
    {
      path: 'reset-password',
      element: <ResetPassword />
    }
  ]
};

export default LoginRoutes;
